import * as Yup from 'yup'

export const Validation = Yup.object({
  privacyCheckbox: Yup.boolean().isTrue('Accepting Privacy policy is required'),
  tcCheckbox: Yup.boolean().isTrue('Accepting Terms of service is required'),
})
